import { NoSsr } from '@mui/material';
import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';
import AddressAutocomplete, {
  AddressAutocompleteProps,
} from 'components/formik/core/FormikAddressAutocomplete/AddressAutocomplete';

export const FormikAddressAutocomplete = (props: AddressAutocompleteProps) => {
  return (
    <NoSsr>
      <AddressAutocomplete {...props} />
      <AlluraFormikErrorMessage fieldName={`${props.formikPrefix}ADDRESS.COUNTRY`} />
    </NoSsr>
  );
};
